import Sortable from 'sortablejs/Sortable';
export default class PageController {
  constructor(ProductPagesDataProvider, $state, $document, $scope) {
    "ngInject"
    this.ProductPagesDataProvider = ProductPagesDataProvider;
    this.$state = $state;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = {10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All'};
    this.type = 3;
    this.field = 'category_id,sub_category,order_by';
    this.order_type = 'asc';
    this.col = 0;
    this.colTopDown = 0;
    this.$document = $document;
    this.categoryId = $state.params.categoryId;
    this.subCategoryId = $state.params.subCategoryId;
    if (this.categoryId != undefined && this.subCategoryId != undefined) {
      this.pageLimit = '9999';
      let
        el = document.getElementById('items');
      let
        vm = this;
      vm.sortingLog = [];
      let
        sortable = Sortable.create(el, {
          onStart: function (evt) {
            evt.oldIndex;
            console.log('start');
          },
          onEnd: function (evt) {
            let
              oldData = angular.copy(vm.productPages);
            let
              i = 0;
            if (evt.oldIndex < evt.newIndex) {
              for (i = evt.oldIndex; i <= evt.newIndex; i++) {
                if (i == evt.newIndex) {
                  vm.productPages[i] = oldData[evt.oldIndex];
                }
                else {
                  vm.productPages[i] = oldData[i + 1];
                }
              }
            }
            if (evt.oldIndex > evt.newIndex) {
              for (i = evt.oldIndex; i >= evt.newIndex; i--) {
                if (i == evt.newIndex) {
                  vm.productPages[i] = oldData[evt.oldIndex];
                }
                else {
                  vm.productPages[i] = oldData[i - 1];
                }
              }
            }
            vm.productPages.map(function (i) {
              vm.sortingLog.push(i.id);
            });
            ProductPagesDataProvider.updateProductPageOrder(vm.sortingLog).then(function (result) {
              vm.getProductPage();
            });
            vm.sortingLog = [];
          }
        });
    }
    this.getProductPage();
  }

  getSortRecors(field, order_type, col, colTopDown) {
    this.field = field;
    this.order_type = order_type;
    this.col = col;
    this.colTopDown = colTopDown;
    this.getProductPage();
  }

  getProductPage() {
    let
      vm = this;
    let data = [];
    data.currentPage = vm.currentPage;
    data.pageLimit = vm.pageLimit;
    data.field = vm.field;
    data.order_type = vm.order_type;
    data.categoryId = 0;
    if (vm.categoryId != undefined) {
      data.categoryId = vm.categoryId;
    }
    data.subCategoryId = 0;
    if (vm.subCategoryId != undefined) {
      data.subCategoryId = vm.subCategoryId;
    }
    vm.ProductPagesDataProvider.getProductPages(data, vm.type).then(function (result) {
      vm.productPages = result.data;
      vm.productPagesTotal = result.total;
    });
  }

  changeStatus(status, id) {
    let
      vm = this;
    let
      data = {'status': status, 'id': id}
    vm.ProductPagesDataProvider.updateProductPageStatus(data).then(function (resp) {
      vm.pages = resp;
      vm.getProductPage();
    })
  }

  removeProductPage(id) {
    if (confirm("Are you sure to delete!") !== true) {
      return false;
    }
    let vm = this;
    vm.ProductPagesDataProvider.removeProductPage(id).then(function (res) {
      vm.getProductPage();
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-page/components/listing/controller.js
 **/